var render = function () {
  var _vm$content, _vm$content2, _vm$content3, _vm$content4, _vm$content5, _vm$content6;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.noContent ? _c('div', {
    staticClass: "content-page"
  }, [!((_vm$content = _vm.content) !== null && _vm$content !== void 0 && _vm$content.hideHeader) ? _c('the-guest-header', {
    staticClass: "content-page__header"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'content-page__table': ((_vm$content2 = _vm.content) === null || _vm$content2 === void 0 ? void 0 : _vm$content2.method) === 'Wysiwyg'
    }
  }, [(_vm$content3 = _vm.content) !== null && _vm$content3 !== void 0 && _vm$content3.header ? _c('h1', [_vm._v("\n            " + _vm._s((_vm$content4 = _vm.content) === null || _vm$content4 === void 0 ? void 0 : _vm$content4.header) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s((_vm$content5 = _vm.content) === null || _vm$content5 === void 0 ? void 0 : _vm$content5.content)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "promopage"
    }
  })]), _vm._v(" "), !((_vm$content6 = _vm.content) !== null && _vm$content6 !== void 0 && _vm$content6.hideFooter) ? _c('div', [_c('app-divider', {
    staticClass: "content-page__divider"
  }), _vm._v(" "), _c('the-footer')], 1) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }